export default "__VITE_ASSET__DuHrq3j2__"